export default () => ({
    init() {
        if (!this.$el._initialized) {
            this.$el._initialized = true;
            toggleCard(this.$el);
        }
    },
    destroy() {
    }
});

// Collapse/expand a card body independently of the checkbox state
function toggleCard(el) {
    const checkbox = el.querySelector('input[type="checkbox"]');
    const cardHeader = el.querySelector('.card-header');
    const cardBody = el.querySelector('.card-body');

    // Initial state: open if the checkbox is checked, collapsed otherwise
    let isOpen = checkbox ? checkbox.checked : true;

    // Append a chevron icon to the header
    cardHeader.classList.add('d-flex', 'justify-content-between', 'align-items-center');
    const chevron = document.createElement('i');
    chevron.className = 'fa fa-chevron-up ms-2 toggle-chevron';
    chevron.style.cursor = 'pointer';
    cardHeader.appendChild(chevron);

    const updateCollapse = () => {
        cardBody.style.display = isOpen ? '' : 'none';
        chevron.className = isOpen
            ? 'fa fa-chevron-up ms-2 toggle-chevron'
            : 'fa fa-chevron-down ms-2 toggle-chevron';
    };

    const updateDisabled = () => {
        const disabled = checkbox ? !checkbox.checked : false;

        cardBody.querySelectorAll('input, textarea').forEach(el => {
            el.readOnly = disabled;
        });

        cardBody.querySelectorAll('select, button').forEach(el => {
            el.style.pointerEvents = disabled ? 'none' : '';
            el.style.opacity = disabled ? '0.6' : '';
        });

        cardBody.querySelectorAll('.dropzone').forEach(el => {
            el.style.pointerEvents = disabled ? 'none' : '';
            el.style.opacity = disabled ? '0.6' : '';
            el.disabled = disabled;
        });

        cardBody.classList.toggle('bg-light', disabled);
        cardBody.classList.toggle('text-muted', disabled);
    };

    // Toggle on header click, but ignore clicks on the checkbox or its label
    cardHeader.addEventListener('click', (e) => {
        if (e.target.closest('input') || e.target.closest('label')) return;
        isOpen = !isOpen;
        updateCollapse();
    });

    // Enabling a channel opens the card if collapsed; disabling does not close it
    if (checkbox) {
        checkbox.addEventListener('change', () => {
            if (checkbox.checked && !isOpen) {
                isOpen = true;
                updateCollapse();
            }
            updateDisabled();
        });
    }

    updateCollapse(); // apply initial collapse state
    updateDisabled(); // apply initial disabled state
}
